import type { ReactNode } from 'react';
import { Shield, AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RoleHintProps {
  variant: 'internal' | 'external';
  children: ReactNode;
}

export function RoleHint({ variant, children }: RoleHintProps) {
  const isInternal = variant === 'internal';

  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-lg px-4 py-3 text-sm',
        isInternal
          ? 'bg-purple-50 border border-purple-200 text-purple-800'
          : 'bg-amber-50 border border-amber-200 text-amber-800'
      )}
    >
      {isInternal ? (
        <Shield className="w-4 h-4 mt-0.5 shrink-0 text-purple-500" />
      ) : (
        <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0 text-amber-500" />
      )}
      <span>{children}</span>
    </div>
  );
}
